exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "li.treeview ul.treeview-menu {\r\n    margin-left: 10px;\r\n}\r\n\r\ndiv.input-group-addon span.btn-box-tool {\r\n    padding: 0px;\r\n}\r\n\r\ndiv.input-group-addon div.icheck {\r\n    margin-top: 0px !important;\r\n    margin-bottom: 0px !important;\r\n}", ""]);

// exports
